import { Link } from 'react-router-dom';
import { ArrowRight, Mail, MapPin, Phone } from 'lucide-react';
import Metadata from '../components/Metadata';
import PageHero from '../components/PageHero';
import SectionHeading from '../components/SectionHeading';
import ContactForm from '../components/ContactForm';
import { assets, company, pageMeta } from '../data/siteData';
import { assetUrl } from '../lib/media';

export default function ContactPage() {
  return (
    <>
      <Metadata
        title={pageMeta.contact.title}
        description={pageMeta.contact.description}
        image={assetUrl(pageMeta.contact.ogImage, 1200)}
        path="/kontakt"
      />

      <PageHero
        eyebrow="Kontakt"
        title="Kontakt RS Byg for et uforpligtende tilbud"
        description="Vi svarer gerne på spørgsmål om træterrasser, renovering, tagudskiftning samt vinduer og døre."
        image={assets.windows}
        primaryAction={{ label: 'Ring 42 30 79 39', href: company.phoneHref }}
        secondaryAction={{ label: 'Se galleri', to: '/galleri' }}
      />

      <section className="bg-white py-20 sm:py-24">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-8">
          <div className="space-y-6">
            <SectionHeading
              eyebrow="Kontaktinformation"
              title="Du kan altid komme i direkte kontakt med RS Byg"
              description="Telefon, e-mail og adresse er samlet her, så du hurtigt kan komme videre med din forespørgsel."
            />

            <div className="grid gap-4">
              <article className="border border-brand-gray-200 bg-brand-gray-50 p-5">
                <div className="flex items-start gap-3">
                  <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                  <div>
                    <span className="block text-xs font-bold uppercase tracking-[0.18em] text-brand-gray-500">Telefon</span>
                    <a href={company.phoneHref} className="mt-1 inline-flex text-sm font-bold text-brand-black whitespace-nowrap">
                      {company.phone}
                    </a>
                  </div>
                </div>
              </article>
              <article className="border border-brand-gray-200 bg-brand-gray-50 p-5">
                <div className="flex items-start gap-3">
                  <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                  <div>
                    <span className="block text-xs font-bold uppercase tracking-[0.18em] text-brand-gray-500">E-mail</span>
                    <a href={company.emailHref} className="mt-1 inline-flex text-sm font-bold text-brand-black whitespace-nowrap">
                      {company.email}
                    </a>
                  </div>
                </div>
              </article>
              <article className="border border-brand-gray-200 bg-brand-gray-50 p-5">
                <div className="flex items-start gap-3">
                  <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                  <div>
                    <span className="block text-xs font-bold uppercase tracking-[0.18em] text-brand-gray-500">Adresse</span>
                    <p className="mt-1 text-sm font-bold text-brand-black">{company.address}</p>
                  </div>
                </div>
              </article>
            </div>

            <div className="border border-brand-gray-200 bg-brand-black p-6 text-white">
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">Hurtig kontakt</p>
              <h2 className="mt-4 font-display text-3xl font-bold tracking-tight">
                Vil du hurtigt videre med projektet?
              </h2>
              <p className="mt-4 text-sm leading-7 text-brand-gray-200">
                Ring eller send en besked, så finder vi sammen den løsning, der passer til opgaven.
              </p>
              <a href={company.phoneHref} className="mt-6 inline-flex items-center justify-center border border-white/20 px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:border-brand-orange hover:text-brand-orange whitespace-nowrap">
                Ring {company.phone}
              </a>
            </div>
          </div>

          <div>
            <SectionHeading
              eyebrow="Kontaktformular"
              title="Send en besked, så vender vi tilbage"
              description="Formularen er fuldt responsiv og har korrekt validering for navn, telefon, e-mail og projektbeskrivelse."
            />
            <div className="mt-8">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-brand-gray-200 bg-brand-gray-50 py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-3 border border-brand-gray-200 bg-white p-6 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand-orange">Næste skridt</p>
              <h2 className="mt-3 font-display text-2xl font-bold text-brand-black">
                Se også vores ydelser og galleri
              </h2>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link to="/ydelser" className="inline-flex items-center justify-center border border-brand-gray-200 px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-brand-black transition-colors hover:border-brand-orange hover:text-brand-orange">
                Se ydelser
                <ArrowRight className="ml-3 h-4 w-4" />
              </Link>
              <Link to="/galleri" className="inline-flex items-center justify-center bg-brand-black px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-brand-orange">
                Se galleri
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
